import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider, CssBaseline } from "@mui/material"; // Import ThemeProvider and CssBaseline for global resets
import { useMode, ColorModeContext } from "./theme"; // Import your theme and color mode context
import reportWebVitals from "./reportWebVitals";
import { UserProvider } from "../src/app/pages/authentification/UserContext";
import { BrowserRouter as Router } from "react-router-dom";

const Main = () => {
  const [theme, colorMode] = useMode(); // Use the custom hook to get the theme and color mode

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />{" "}
        {/* Ensures global reset styles and your custom theme styles */}
        <UserProvider>
          <Router>
            <App />
          </Router>
        </UserProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Main />{" "}
    {/* Render the Main component that now wraps everything with the ThemeProvider and other providers */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
